/* eslint-disable react/prop-types */

/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

// Packages
import React from 'react'
// Styles
import { Select, Tag } from 'antd'
// import { SELECTION_ALL } from 'antd/lib/table/hooks/useSelection'
// For antd
const { Option } = Select

const SelectMrtStation = ({ mrtStationsList, currentUserBranches, onChange, coyId }) => {
	// const [currentMrtStation, setCurrentMrtStation] = useState([])

	// const getSelectedMrtStations = () => {
	//   if (selectedMrtStation && selectedMrtStation.length) {
	//     setCurrentMrtStation(selectedMrtStation)
	//   }
	// }

	// useEffect(() => {
	//   getSelectedMrtStations()
	// }, [])

	const handleSelectedMrt = (value) => {
		if (value.indexOf('select-all') !== -1) {
			value = mrtStationsList.map((mrt) => {
				return mrt.id
			})
		} else if (value.indexOf('unselect-all') !== -1) {
			value = []
		}
		// setCurrentMrtStation(value)
		onChange(value)
	}

	const getSelectedTrainStations = (coyId) => {
		const correspondingCoy = currentUserBranches.find(Branch => Branch.companyId === coyId)
		return correspondingCoy.selectedMrtStations
	}

	return (
		<>
			<Select
				mode='multiple'
				style={{ width: '100%' }}
				onChange={handleSelectedMrt}
				// value={currentMrtStation}
				value={getSelectedTrainStations(coyId)}
				optionFilterProp='name'
				maxTagCount={4}
				placeholder='Select MRT Stations'
			>
				{getSelectedTrainStations(coyId).length !== mrtStationsList.length &&
          <Option value='select-all'>Select All</Option>}
				{getSelectedTrainStations(coyId).length > 0 &&
          <Option value='unselect-all'>Unselect All</Option>}
				{mrtStationsList.map((station) => {
					return (
						<Option key={station.id} name={station.id + station.name}>
							<Tag color={station.MrtLine.colour}>
								<span style={{ fontWeight: 'bold' }}>{station.id}</span>&nbsp;{station.name}
							</Tag>
						</Option>
					)
				})}
			</Select>
		</>
	)
}

export default SelectMrtStation
